import reducer from './reducers';
import * as confirmationsActions from './actions';
import * as confirmationsSelectors from './selectors';

export { confirmationsActions, confirmationsSelectors };
export default reducer;